import { render, staticRenderFns } from "./FormControlSelect.vue?vue&type=template&id=5d72e684&"
import script from "./FormControlSelect.vue?vue&type=script&lang=js&"
export * from "./FormControlSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports